import { Box, HStack, Kbd, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface KeyboardHintProps {
  label: string;
  keys: ReactNode[];
}
export const KeyboardHint: React.FC<KeyboardHintProps> = ({ keys, label }) => {
  return (
    <HStack gap={1} fontSize="xs">
      <HStack gap={1} fontSize="xs" separator={<Box border={"none"}>+</Box>}>
        {keys.map((key, index) => (
          <Kbd key={index}>{key}</Kbd>
        ))}
      </HStack>
      <Text>{label}</Text>
    </HStack>
  );
};
